import {TasksI18n} from '@/locales/base.message.locales';

export const tasks: TasksI18n = {
  buttons: {
    abort: 'Abandonar tarefa',
    accept: 'Aceitar tarefa'
  },
  labels: {
    users: 'Usuário |  Usuários',
    already_in: 'Você ja esta nesta Tarefa'
  },
  messages: {
    abort_fail: 'Falhou ao abandonar a tarefa',
    abort_success: 'Tarefa abandonada',
    accept_fail: 'Falhou ao aceitar a tarefa',
    accept_success: 'Tarefa aceita'
  },
};
